module.exports = __webpack_public_path__ + "img/brunei-darussalam.4a822e81.svg";